import React from 'react';
import { Routes, Route } from 'react-router-dom';
import VendorList from './VendorList';
import VendorDetails from './VendorDetails';
import { VendorComparison } from './VendorComparison';
import { VendorFormPage } from './VendorFormPage';

const VmsApp: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<VendorList />} />
      <Route path="/vendor/add" element={<VendorFormPage />} />
      <Route path="/vendor/edit/:id" element={<VendorFormPage />} />
      <Route path="/vendor/:id" element={<VendorDetails />} />
      <Route path="/compare" element={<VendorComparison />} />
    </Routes>
  );
};

export default VmsApp;
